
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"57.723","height":"31.516"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 712"}},[_c('path',{attrs:{"data-name":"Path 7006","d":"M42.323 12.882H13.001l-5.3 9.1-3.515 6.029a.433.433 0 01-.031.053l-1.515 2.6h29.322l5.3-9.1 5.061-8.681zm6.576 8.681l4.6 7.892v-9.806l-2.577 2.479a.457.457 0 01-.628 0 .416.416 0 010-.6l3.2-3.083V14.07l-2.577 2.479a.457.457 0 01-.628 0 .416.416 0 010-.6l3.335-3.209a.457.457 0 01.628 0l3.335 3.209a.416.416 0 010 .6.457.457 0 01-.628 0l-2.577-2.479v4.375l3.205 3.083a.416.416 0 010 .6.457.457 0 01-.628 0l-2.571-2.479v11.44a.436.436 0 01-.444.427H1.878a.456.456 0 01-.217-.054.418.418 0 01-.17-.581l1.844-3.163V16.39L.758 18.869a.457.457 0 01-.628 0 .416.416 0 010-.6l3.205-3.083v-4.375L.758 13.29a.457.457 0 01-.628 0 .416.416 0 010-.6l3.335-3.209a.457.457 0 01.628 0l3.335 3.209a.416.416 0 010 .6.457.457 0 01-.628 0l-2.577-2.479v4.375l3.2 3.083a.416.416 0 010 .6.457.457 0 01-.628 0L4.218 16.39v9.8l2.7-4.631 5.418-9.293a.446.446 0 01.4-.242h3.788V7.037l-2.577 2.479a.457.457 0 01-.628 0 .416.416 0 010-.6l3.2-3.083V1.458l-2.577 2.479a.457.457 0 01-.628 0 .416.416 0 010-.6L16.649.128a.457.457 0 01.628 0l3.335 3.209a.416.416 0 010 .6.457.457 0 01-.628 0l-2.577-2.479v4.375l3.2 3.083a.416.416 0 010 .6.457.457 0 01-.628 0l-2.577-2.479v4.987h25.711a.442.442 0 01.329.2l.009.015-.005-.009 5.436 9.323zm-10.864.417l-5.061 8.681h5.007l4.711-8.08a.434.434 0 01.172-.166.453.453 0 01.6.163l4.713 8.083h5.007l-5.061-8.681-5.045-8.654-5.045 8.654zm.962 8.681h8.166l-4.083-7-4.083 7z","fill":"#088dd1"}})])])
          )
        }
      }
    